import { Button, Text } from 'react-native-elements';
import { View, useWindowDimensions } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { ModalLayout } from '../../../common/ui/components/modal-layout.component';
import React from 'react';
import i18n from 'i18n-js';
import { isWeb } from '../../../common/utils/platform.utils';
import moment from 'moment';
import theme from '../../../common/ui/theme';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { MaskedText } from 'react-native-mask-text';
import { TextGradient } from '../../../common/ui/elements/text-gradient.element';
import { TextCurrency } from '../../../common/ui/elements/text-currency.element';

export const WithDrawTransferredFund = () => {
    const { width } = useWindowDimensions();
    const navigation = useNavigation();
    const today = moment().toDate();

    const {
        params: { data },
    } = useRoute();

    const accountFromBalance = data?.fromAccount?.balances?.find(
        (b) => b.type === 'ACCOUNT_BALANCE'
    );

    const accountToBalance = data?.toAccount?.balances?.find(
        (b) => b.type === 'ACCOUNT_BALANCE'
    );

    return (
        <ModalLayout>
            <View style={{ flex: 1 }}>
                <View style={{ flexDirection: 'column', marginBottom: 15 }}>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_700Bold',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            letterSpacing: 0.15,
                        }}
                    >
                        {i18n.t('pages.moveMoney.withdrawFund.fundtransfer.form.amount')}
                    </Text>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_400Regular',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            textTransform: 'capitalize',
                            letterSpacing: 0.15,
                        }}
                    >
                        {'$' + data.amount + '.00'}
                    </Text>
                </View>
                {data?.when && (
                    <View
                        style={{
                            flexDirection: 'column',
                            marginBottom: 15,
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 16,
                                fontFamily: 'DMSans_700Bold',
                                lineHeight: 28,
                                color: 'rgba(0, 0, 0, 0.87)',
                                textTransform: 'capitalize',
                                letterSpacing: 0.15,
                            }}
                        >
                            {i18n.t('pages.moveMoney.withdrawFund.fundtransfer.form.submit')}
                        </Text>
                        <Text
                            style={{
                                fontSize: 16,
                                fontFamily: 'DMSans_400Regular',
                                lineHeight: 28,
                                color: 'rgba(0, 0, 0, 0.87)',
                                textTransform: 'capitalize',
                                letterSpacing: 0.15,
                            }}
                        >
                            {moment(new Date(today)).format('MMM DD, YYYY h:mm A')}
                        </Text>
                    </View>
                )}
                {data?.when && (
                    <View
                        style={{
                            flexDirection: 'column',
                            marginBottom: 15,
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 16,
                                fontFamily: 'DMSans_700Bold',
                                lineHeight: 28,
                                color: 'rgba(0, 0, 0, 0.87)',
                                textTransform: 'capitalize',
                                letterSpacing: 0.15,
                            }}
                        >
                            {i18n.t('pages.moveMoney.withdrawFund.fundtransfer.form.when')}
                        </Text>
                        <Text
                            style={{
                                fontSize: 16,
                                fontFamily: 'DMSans_400Regular',
                                lineHeight: 28,
                                color: 'rgba(0, 0, 0, 0.87)',
                                textTransform: 'capitalize',
                                letterSpacing: 0.15,
                            }}
                        >
                            {moment(data?.when).format('MMMM DD, YYYY')}
                        </Text>
                    </View>
                )}
                <View style={{ flexDirection: 'column', marginBottom: 15 }}>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_700Bold',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            textTransform: 'capitalize',
                            letterSpacing: 0.15,
                        }}
                    >
                        {i18n.t('pages.moveMoney.withdrawFund.fundtransfer.form.from')}
                    </Text>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_400Regular',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            textTransform: 'capitalize',
                            letterSpacing: 0.15,
                        }}
                    >
                        {data?.fromAccount?.account_type} {' '}
                        <MaskedText mask="**** **** **** 9999">
                            {data?.fromAccount?.account_number}
                        </MaskedText>
                    </Text>
                    <TextGradient
                        style={{
                            fontSize: 16,
                            marginTop: 'auto',
                            alignSelf: 'flex-start',
                            ...theme.typography.mediumFontWeight,
                        }}
                    >
                        <TextCurrency
                            value={
                                accountFromBalance &&
                                accountFromBalance.balance / 100
                            }
                        />
                    </TextGradient>
                </View>
                <View style={{ flexDirection: 'column', marginBottom: 15 }}>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_700Bold',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            textTransform: 'capitalize',
                            letterSpacing: 0.15,
                        }}
                    >
                        {i18n.t('pages.moveMoney.withdrawFund.fundtransfer.form.to')}
                    </Text>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_400Regular',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            letterSpacing: 0.15,
                        }}
                    >
                        {data?.toAccount?.type} {' '}
                        <MaskedText mask="**** **** **** 9999">
                            {data?.toAccount?.vendor_data.account_number_mask}
                        </MaskedText>
                    </Text>
                    <Text
                        style={{
                            fontSize: 16,
                            fontFamily: 'DMSans_400Regular',
                            lineHeight: 28,
                            color: 'rgba(0, 0, 0, 0.87)',
                            letterSpacing: 0.15,
                        }}
                    >
                        {data?.toAccount.routing_identifiers.bank_name}
                    </Text>
                    <TextGradient
                        style={{
                            fontSize: 16,
                            marginTop: 'auto',
                            alignSelf: 'flex-start',
                            ...theme.typography.mediumFontWeight,
                        }}
                    >
                        <TextCurrency
                            value={
                                accountToBalance &&
                                accountToBalance.balance / 100
                            }
                        />
                    </TextGradient>
                </View>
                <View
                    style={{
                        bottom: 20,
                        position: isWeb() ? 'fixed' : 'absolute',
                        width: width - 50,
                    }}
                >
                    <Button
                        buttonStyle={theme.styles.buttonStylePrimary}
                        titleStyle={theme.styles.titleStylePrimary}
                        loadingProps={{
                            color: theme.colors.textHeading,
                        }}
                        title={i18n.t('common.backToAccount')}
                        onPress={() => navigation.push('MoveMoney.DetailsList')}
                    />
                    <TouchableOpacity onPress={() => navigation.push('MoveMoney.DetailsList')}>
                        <Text
                            style={{
                                fontFamily: 'DMSans_500Medium',
                                color: "#00008E",
                                fontSize: 14,
                                lineHeight: 24,
                                textAlign: 'center',
                                textDecorationLine: 'underline',
                                marginTop: 30
                            }}
                        >
                            {i18n.t('common.anotherTransfer')}
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </ModalLayout>
    );
};


